import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, svgSprite } from '../../hybrid/wrappers';
import { API_SERVER_URL } from '../../common/utils/utils';
import { createdEndOfUrl } from './helpers';
import css from './excel.module.scss';
import classNames from 'classnames';
import { useExelDownload } from './ExelDownload/ExelDownload';
import { UserProfileContext } from '../../common/utils/getContext';
import T from '../../common/components/T';

const ExcelButton = (props) => {
    const { officePage } = useContext(UserProfileContext);
    const { exportData, filter, customStyles } = props;
    const endUrlFilter = filter && !exportData?.withOutFilters ? createdEndOfUrl(filter.current, exportData?.startFilter) : '';

    const styles = { ...css, ...props.customStyles };
    const { onClick, Modal } = useExelDownload(
        exportData.customUrl
            ? `${exportData.customUrl}api/v1/${exportData.exportUrl}/export${endUrlFilter}`
            : exportData.fullUrl
            ? `${exportData.fullUrl}${endUrlFilter}`
            : `${API_SERVER_URL}/api/v1/${exportData.exportUrl}/export${endUrlFilter}`,
        exportData,
        customStyles
    );
    return (
        <>
            <Tooltip
                text={officePage ? <T textName='export-excel-tooltip' defaultStr='Экспортировать данные в формате .XLS' /> : null}
            >
                {exportData?.type == 'button' ? (
                    <div
                        onClick={onClick}
                        className={classNames(
                            exportData?.modeButton ? styles[`${exportData?.modeButton}`] : styles.exportBtnText || '',
                            styles.customExportBtnText || ''
                        )}
                    >
                        <T textName='export-excel-text' defaultStr='Скачать в excel' />
                    </div>
                ) : (
                    <div onClick={onClick} className={classNames(styles.exportBtn || '', styles.customExportBtn || '')}>
                        {svgSprite(exportData.icon || (officePage ? 'file-download-gt' : 'excel-image'), {
                            width: '22px',
                            height: '22px'
                        })}
                    </div>
                )}
            </Tooltip>

            {Modal}
        </>
    );
};

ExcelButton.propTypes = {
    filter: PropTypes.object,
    exportData: PropTypes.object,
    styles: PropTypes.object,
    customStyles: PropTypes.object
};

export default ExcelButton;
